/**
 * Generated by orval v8.2.0 🍺
 * Do not edit manually.
 * Selfserv Unauth Ext Api
 * Openapi v1 integration spec for Selfserv unauth API Gateway
 * OpenAPI spec version: 1.0.0
 */
import { useMutation } from '@tanstack/react-query';
import { unauthHttpRequest } from '../../../../service';
/**
 * POST /customers/data/bootstrap on the unauth gateway (customer data bootstrap).
 * Bootstrap customer data to warm up backend caches.
 * @summary Customer Data Bootstrap
 */
export const postDataBootstrap = (dataBootstrapRequestBody, signal) => {
    return unauthHttpRequest({ url: `/customers/data/bootstrap`, method: 'POST',
        headers: { 'Content-Type': 'application/json', },
        data: dataBootstrapRequestBody, signal
    });
};
export const getPostDataBootstrapMutationOptions = (options) => {
    const mutationKey = ['postDataBootstrap'];
    const { mutation: mutationOptions } = options ?
        options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
            options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey, } };
    const mutationFn = (props) => {
        const { data } = props ?? {};
        return postDataBootstrap(data);
    };
    return { mutationFn, ...mutationOptions };
};
/**
 * @summary Customer Data Bootstrap
 */
export const usePostDataBootstrap = (options) => {
    const mutationOptions = getPostDataBootstrapMutationOptions(options);
    return useMutation(mutationOptions);
};
//# sourceMappingURL=postDataBootstrap.js.map